import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconHomeDollar: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2892 7.06916L11.7209 2.49163C10.7234 1.67246 9.27588 1.67163 8.27838 2.49163L2.71005 7.06916C2.06838 7.59666 1.76256 8.43245 1.91089 9.24995L3.12346 15.9025C3.35846 17.19 4.47929 18.125 5.78846 18.125H14.2093C15.5184 18.125 16.6393 17.19 16.8743 15.9025L18.0867 9.24995C18.2367 8.43245 17.9309 7.59666 17.2892 7.06916ZM16.8576 9.02585L15.6451 15.6783C15.5193 16.3716 14.9151 16.875 14.2101 16.875H5.78927C5.08427 16.875 4.4809 16.3716 4.35423 15.6783L3.14177 9.02666C3.07343 8.65499 3.21263 8.27494 3.50513 8.03494L9.07337 3.45751C9.3417 3.23667 9.67092 3.12659 10.0001 3.12659C10.3293 3.12659 10.6585 3.23749 10.9268 3.45832L16.495 8.03575C16.7867 8.27492 16.9259 8.65418 16.8576 9.02585ZM12.0834 12.1775C12.0834 12.675 11.8917 13.1442 11.5417 13.4975C11.2876 13.7567 10.9701 13.9292 10.6251 14.005V14.1666C10.6251 14.5116 10.3451 14.7916 10.0001 14.7916C9.65508 14.7916 9.37508 14.5116 9.37508 14.1666V14.0042C8.61258 13.8358 8.01845 13.1975 7.92845 12.3833C7.89012 12.04 8.13759 11.7308 8.48092 11.6933C8.81509 11.6566 9.13177 11.9024 9.17011 12.2458C9.20511 12.5624 9.4634 12.8008 9.7709 12.8008H10.2301C10.3876 12.8008 10.5376 12.7367 10.6517 12.6208C10.7701 12.5008 10.8342 12.3442 10.8342 12.1775C10.8342 11.8908 10.6442 11.6416 10.3742 11.5716L9.31842 11.3058C8.91592 11.2016 8.55589 10.9641 8.30422 10.6349C8.05506 10.3158 7.91675 9.9066 7.91675 9.4891C7.91675 8.59327 8.54258 7.84496 9.37508 7.66079V7.49997C9.37508 7.15497 9.65508 6.87497 10.0001 6.87497C10.3451 6.87497 10.6251 7.15497 10.6251 7.49997V7.66242C11.3876 7.83076 11.9817 8.46915 12.0717 9.28331C12.1101 9.62665 11.8626 9.93581 11.5192 9.97332C11.1859 10.0083 10.8684 9.76418 10.8301 9.42085C10.7951 9.10418 10.5368 8.86583 10.2293 8.86583H9.77008C9.43758 8.86583 9.16594 9.14494 9.16594 9.4891C9.16594 9.63077 9.21092 9.76659 9.29258 9.87159C9.37925 9.98492 9.49346 10.0608 9.62512 10.095L10.6809 10.3608C11.5084 10.5733 12.0834 11.32 12.0834 12.1775Z"
      fill={color}
    />
  </svg>
);

export default IconHomeDollar;
